import { CartSolidIcon } from "../icon/CartSolidIcon";
import { Body14Medium } from "../typography/Body14Medium";

export const PartnerProductOrderCartEmptyBody = () => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center">
      <div className="flex items-center justify-center w-[48px] h-[48px] bg-grayscale-contrast-20 rounded-full">
        <CartSolidIcon color="text-primary-white" />
      </div>
      <Body14Medium className="mt-[16px] text-semantic-text-disabled">
        담긴 상품이 없습니다.
      </Body14Medium>
    </div>
  );
};
